export default __webpack_public_path__ + "static/media/thumb_2_wr.b4d4d738.png";